const WrenchIcon = () => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0L21.5 5.5a6 6 0 0 1-7.9 7.9L5.9 21.1a2.1 2.1 0 0 1-3-3l7.7-7.7a6 6 0 0 1 7.9-7.9z' />
  </svg>
);

export default WrenchIcon;
